export default __webpack_public_path__ + "static/media/claro.d1f41292.svg";